<div class="modal fade" id="SmsModal" tabindex="-1" aria-labelledby="" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        <h5 class="modal-title ms-0" id="">پیام به دستگاه</h5>
      </div>

      <div class="modal-body" [formGroup]="smsForm">
        <div class="sms-field">
          <label>متن پیام <span class="req">*</span></label>
          <textarea rows="4" formControlName="strSMS" placeholder="متن پیام خود را وارد کنید" class="form-control"
            [ngClass]="smsForm.get('strSMS')?.value != '' ? 'text-end' : 'text-start'">
          </textarea>
        </div>
        <div class="sms-mode">
          <span class="sms-mode-label">روش ارسال:</span>
          <div class="sms-seg">
            <button type="button" [class.active]="!isGprs" (click)="setMode(false)">
              <i class="fa fa-comment"></i> SMS
            </button>
            <button type="button" [class.active]="isGprs" (click)="setMode(true)">
              <i class="fa fa-signal"></i> GPRS
            </button>
          </div>
        </div>
      </div>

      <div class="modal-footer sms-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">
          بستن
        </button>
        <button type="button" class="btn btn-success sms-send" (click)="send()">
          <i class="fa fa-send"></i> {{ smsForm.get('bGPRS')?.value ? 'GPRS ارسال' : 'SMS ارسال' }}
        </button>
      </div>
    </div>
  </div>
</div>
